module.exports = __webpack_public_path__ + "img/ILEK.8b983ded.png";